import {call, put, select, takeEvery, takeLatest} from "redux-saga/effects";
import {
    onOrdersLoad,
    onOrdersLoadSuccess,
    onOrdersLoadFail,
    onOrderLoadDetails,
    onOrderLoadDetailsSuccess,
    onOrderLoadDetailsFail,
    onOrderActionClickFail,
    onOrderActionClickSuccess,
    onOrderActionClick,
    onOrdersCloseOrder,
    onOrderVisibleRefundReason,
    onStaffOrdersLoad,
    onChainOrdersLoad
} from './actions';

import { actionOrder, loadOrderDetails, loadOrders, loadStaffOrders } from './api';

function* fetchInitData(action) {
    try {
        const orders = yield select(state => state.orders);

        const filter = {
            page: action.page,
            type: orders.type,
            orderId: orders.orderId,
            restaurant: orders.restaurant,
            name: orders.name,
            tag: orders.tag,
        }

        const response = yield call(loadOrders, filter)
        yield put(onOrdersLoadSuccess(response))
    }
    catch (e) {
        yield put(onOrdersLoadFail())
    }
}

function* fetchStaffOrders(action) {
    try {
        const orders = yield select(state => state.orders);

        const filter = {
            page: action.page,
            type: orders.type,
            orderId: orders.orderId,
            restaurant: orders.restaurant,
            name: orders.name,
            tag: orders.tag,
        }
        const response = yield call(loadOrders, filter)
        yield put(onOrdersLoadSuccess(response))
    }
    catch (e) {
        yield put(onOrdersLoadFail())
    }
}

function* fetchChainOrders(action) {
    try {
        const response = yield call(loadOrders, action.filters)
        yield put(onOrdersLoadSuccess(response))
    }
    catch (e) {
        yield put(onOrdersLoadFail())
    }
}

function* loadDetails(action) {
    try {
        const response = yield call(loadOrderDetails, action.orderId)
        yield put(onOrderLoadDetailsSuccess(response))
    }
    catch (e) {
        yield put(onOrderLoadDetailsFail(e))
    }
}

function* actionClick(action) {
    try {
        const params = yield select(({ orders }) => ({
            refund_reason: orders.refundReason,
            refund_reason_text: orders.refundReasonText,
            refund_reason_amount: orders.refundReasonAmount,
        }));

        const response = yield call(actionOrder, action.orderId, action.action, params)
        yield put(onOrderActionClickSuccess(response))
        yield put(onOrdersLoad())
        yield put(onOrdersCloseOrder())
        yield put(onOrderVisibleRefundReason(false))
    }
    catch (e) {
        yield put(onOrderActionClickFail(e))
    }
}

function* ordersSaga() {
    yield takeLatest(onOrdersLoad().type, fetchInitData);
    yield takeLatest(onStaffOrdersLoad().type, fetchStaffOrders);
    yield takeLatest(onChainOrdersLoad().type, fetchChainOrders);
    yield takeEvery(onOrderLoadDetails().type, loadDetails);
    yield takeEvery(onOrderActionClick().type, actionClick);
}

export default ordersSaga;
